import { useState, useRef, useEffect } from 'react'
import MegaMenu from './megamenu'
import { languages } from '../locale'
import { app, translate } from '../app'
import { Link } from 'react-router-dom'
import { translations } from '../translations'
import { CloseOutlined } from './icons'


const MobileNavigationDrawer = ({
  isDrawerOpen,
  setIsDrawerOpen,
  drawerButtonRef,
  menuDataArray,
  header,
  renderMenuItems
}) => {
  const [clicked, setClicked] = useState(null)
  const drawerRef = useRef(null)
  const locale = languages[app.locale]?.zendesk as string ?? app.locale
  const isRTL = languages[app.locale]?.rtl


  useEffect(() => {
    if (isDrawerOpen && drawerRef.current) {
      drawerRef.current.focus()
    }
  }, [isDrawerOpen])

  const handleToggle = (index) => {
    if (clicked === index) {
      return setClicked(null)
    }

    setClicked(index)
  }

  const handleKeyDown = (event) => {
    if (event.key === 'Escape') {
      setIsDrawerOpen(false)
      if (drawerButtonRef.current) {
        drawerButtonRef.current.focus()
      }
    }
  }

  return (
    <div
      className="mobile_navigation"
      ref={drawerRef}
      role="dialog"
      aria-modal="true"
      aria-label={translate(translations.navigationMenu)}
      tabIndex={isDrawerOpen ? 0 : -1}
      onKeyDown={handleKeyDown}
    >
      <div
        className={`drawer_content ${isDrawerOpen ? 'active' : ''}`}
      >
        <div className="close_drawer py-2">
          <button
            tabIndex={isDrawerOpen ? 0 : -1}
            aria-label={translate(translations.close)}
            onClick={() => {
              setIsDrawerOpen(false)
              if (drawerButtonRef.current) {
                drawerButtonRef.current.focus()
              }
            }}
          >
            <CloseOutlined className='text-2xl' aria-hidden="true" />
          </button>
        </div>
        <div className={`list-none mobile-menu ${isRTL ? 'rtl-menu' : ''}`}>
          {renderMenuItems(header.menu)}
          {app.country !== 42 && app.country !== 43 && <li className="">
            <Link to={`/${locale.toLocaleLowerCase()}/search-results`} tabIndex={isDrawerOpen ? 0 : -1} onClick={() => setIsDrawerOpen(false)}>{translate(translations.search)}</Link>
          </li>}
        </div>
        <div>
          {menuDataArray?.map((menuData, index) => (
            <MegaMenu
              handleToggle={handleToggle}
              key={index}
              clicked={clicked}
              setIsDrawerOpen={setIsDrawerOpen}
              menuData={[menuData]}
              isDrawerOpen={isDrawerOpen}
            />
          ))}
        </div>
      </div>
    </div>
  )
}

export default MobileNavigationDrawer
